import { useNavigate } from "react-router-dom";
import { Button, Grid, IconButton, InputAdornment } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createPortal } from "react-dom";
import logingImg from "assets/img/loginImage.jpg";
import LoadingCM from "components/shared/Loading";
import useHttp from "hooks/use-http";
import useAuth from "hooks/use-auth";
import ImgContainer from "components/shared/Image";
import { convertNum } from "helper/convert-num";
import {
  ForgetPassWrapper,
  LeftGrid,
  RightGrid,
  StyledDivider,
  StyledForgetPassText,
  StyledInput,
  StyledTitle,
  StyledAppbarCM,
} from "./LoginColleague.style";
import { loginColleagueSchema } from "validations";
import { StyledLink } from "components/shared/Link";
import { loginColleagueRequest } from "api/requests";
import LoadingPartCM from "components/shared/PartLoading";
import { useState } from "react";
import { BsPhone } from "react-icons/bs";
import { RiLockPasswordLine } from "react-icons/ri";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {Helmet} from "react-helmet";

export default function LoginColleague() {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState({ passwordVisibility: false });
  const { request, loading } = useHttp(false);
  const authCTX = useAuth();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginColleagueSchema),
  });

  const onSubmit = async (values) => {
    let res = await request({
      url: loginColleagueRequest,
      values: {
        phone_number: values.phone_number,
        password: convertNum(values.password),
      },
    });
    if (res) {
      authCTX.login(res.token);
      navigate("/");
    }
  };

  const handleChange = () =>
    setToggle({ passwordVisibility: !toggle.passwordVisibility });

  return createPortal(
    <>
      {/* {loading && <LoadingCM />} */}
      <Helmet>
        <title>ورود همکار - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ height: "100vh" }}
      >
        <LeftGrid item sm={6} xs={6}>
          <ImgContainer
            src={logingImg}
            alt="لوگو"
            // objectFit="contain"
            width="auto"
            height="100%"
          />
        </LeftGrid>
        <RightGrid item lg={6} md={6} sm={6} xs={12}>
          <div>
            <StyledTitle variant="h4" alignSelf="center">
              ورود همکار
            </StyledTitle>
            <StyledInput
              id="userName"
              label="شماره تلفن"
              fullWidth
              type="number"
              {...register("phone_number")}
              error={Boolean(errors["phone_number"])}
              helperText={errors["phone_number"]?.message}
              style={{ direction: "rtl" }}
              InputProps={{
                readOnly: loading ? true : false,
                startAdornment: (
                  <InputAdornment position="start">
                    <BsPhone />
                  </InputAdornment>
                ),
              }}
            />
            <StyledInput
              id="password"
              label="رمز عبور"
              type={toggle.passwordVisibility ? "text" : "password"}
              fullWidth
              {...register("password")}
              error={Boolean(errors["password"])}
              helperText={errors["password"]?.message}
              style={{ direction: "rtl" }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleChange}
                      // onMouseDown={handleMouseDownPassword}
                    >
                      {toggle.passwordVisibility && <Visibility />}
                      {!toggle.passwordVisibility && <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
                startAdornment: (
                  <InputAdornment position="start">
                    <RiLockPasswordLine />
                  </InputAdornment>
                ),
                readOnly: loading ? true : false,
              }}
            />
            <Button
              variant="contained"
              onClick={handleSubmit(onSubmit)}
              fullWidth
              style={{ height: "55px" }}
              disabled={loading ? true : false}
            >
              {loading ? <LoadingPartCM /> : "ورود"}
            </Button>

            <ForgetPassWrapper>
              <StyledDivider variant="middle">یا</StyledDivider>
              <StyledLink to="/login">
                <StyledForgetPassText>
                  آیا شما کاربر ساده هستید : ورود کاربر ساده
                </StyledForgetPassText>
              </StyledLink>
              <StyledLink to="/">
                <StyledForgetPassText sx={{ marginTop: "10px" }}>
                  صفحه اصلی سایت
                </StyledForgetPassText>
              </StyledLink>
            </ForgetPassWrapper>
          </div>
        </RightGrid>
        <StyledAppbarCM />
      </Grid>
    </>,
    document.getElementById("login")
  );
}
